import React from 'react';
import PropTypes from 'prop-types';

import StructureFilterPreview from './StructureFilterPreview';
import Button from '@Components/Button';

import './StructureFilter.custom.scss';
import './StructureFilter.theme.scss';

export function DrawInEditor(props) {
  const { onClick } = props;

  return (
    <Button
      onClick={onClick}
      buttonConfig={{
        type: 'link',
        size: 'sm',
        className: 'structure-filter-drawing',
        label: 'Draw',
        noBorder: true,
        e2eName: 'draw-structure',
      }}
      iconConfig={{
        name: 'structure-draw',
        size: 'lg',
        position: 'before',
        className: 'structure-filter-drawing-icon',
      }}
    />
  );
}

export default function StructureFilter(props) {
  const { onClick, drawing } = props;

  return (
    <section className='structure-filter'>
      {
        drawing ?
          <StructureFilterPreview {...props} /> :
          <DrawInEditor onClick={onClick}/>
      }
    </section>
  );
}

StructureFilter.propTypes = {
  drawing: PropTypes.shape({
    preview: PropTypes.string.isRequired,
  }),
  onClick: PropTypes.func.isRequired,
  drawOnClick: PropTypes.func.isRequired,
  clearDrawn: PropTypes.func.isRequired,
  optionsButtonOnClick: PropTypes.func.isRequired,
};
